import React from "react";
import Footer from "./Footer";

const FooterContainer: React.FC = () => {
  return <Footer />;
};

export default FooterContainer;
